import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/wellnessCheck/importer/wellnessCheckImporterActions';

export default importerReducers(actions);
